import { render, staticRenderFns } from "./InputWorkspaceChoose.vue?vue&type=template&id=79c2cd00&scoped=true"
import script from "./InputWorkspaceChoose.vue?vue&type=script&lang=ts"
export * from "./InputWorkspaceChoose.vue?vue&type=script&lang=ts"
import style0 from "./InputWorkspaceChoose.vue?vue&type=style&index=0&id=79c2cd00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c2cd00",
  null
  
)

export default component.exports